import {
  setTokenPrintaction,
  setTokenPrintclinic,
  setTokenPrintToken,
} from "../redux/printstate/printActions";

type DispatchFn = (action: any) => void;

type ClinicBillData = {
  title?: string;
  tpNo?: string;
  tpNo2?: string;
  website?: string;
  email?: string;
  address?: string;
  printImages?: string;
  headerImages?: string;
  footerImages?: string;
  tokenPrint?: Array<{
    title?: string;
    top?: number;
    left?: number;
    show?: boolean;
    size?: number;
    height?: number;
    width?: number;
  }>;
};

export type TokenPrintPayload = {
  tokenNo: string | number;
  roomNumber?: string | number;
  doctorName?: string;
  patientName?: string;
  issuedAt?: string | Date;
};

export function dispatchTokenPrintLayout(
  dispatch: DispatchFn,
  clinic: ClinicBillData,
  payload: TokenPrintPayload
) {
  clinic?.tokenPrint?.forEach((element) => {
    const { title, top, left, show, size, height, width } = element;
    if (!title) return;
    if (top != null) dispatch(setTokenPrintaction({ name: title, target: "top", value: top }));
    if (left != null) dispatch(setTokenPrintaction({ name: title, target: "left", value: left }));
    if (height != null)
      dispatch(setTokenPrintaction({ name: title, target: "height", value: height }));
    if (width != null)
      dispatch(setTokenPrintaction({ name: title, target: "width", value: width }));
    if (show !== undefined)
      dispatch(setTokenPrintaction({ name: title, target: "show", value: show }));
    if (size != null) dispatch(setTokenPrintaction({ name: title, target: "size", value: size }));
  });

  dispatch(
    setTokenPrintclinic({
      clinicName: clinic?.title,
      tpNo: clinic?.tpNo ?? "",
      phoneTwo: clinic?.tpNo2 ?? "",
      website: clinic?.website ?? "",
      email: clinic?.email ?? "",
      address: clinic?.address,
      drName: payload.doctorName ?? "",
      printImages: clinic?.printImages,
      headerImages: clinic?.headerImages,
      footerImages: clinic?.footerImages,
    })
  );

  dispatch(
    setTokenPrintToken({
      tokenNo: String(payload.tokenNo),
      roomNumber:
        payload.roomNumber != null && String(payload.roomNumber).trim() !== ""
          ? String(payload.roomNumber)
          : "—",
      patientName: payload.patientName ?? "—",
      issuedAt: (() => {
        if (payload.issuedAt instanceof Date) return payload.issuedAt.toISOString();
        if (payload.issuedAt != null && String(payload.issuedAt).trim() !== "") {
          const d = new Date(payload.issuedAt);
          return Number.isNaN(d.getTime())
            ? new Date().toISOString()
            : d.toISOString();
        }
        return new Date().toISOString();
      })(),
    })
  );
}

export function roomNumberFromAppointment(item: any): string {
  const room = String(item?.roomNumber ?? "").trim();
  return room || "—";
}

export function appointmentHasToken(queue: unknown): boolean {
  if (queue == null || queue === "") return false;
  const n = Number(queue);
  return Number.isFinite(n) && n > 0;
}

export function doctorNameFromAppointment(item: any): string {
  const d = item?.doctorId;
  if (!d) return "";

  const first = String(d.firstName ?? "").trim();
  const last = String(d.lastName ?? "").trim();
  const name = [first, last].filter(Boolean).join(" ").trim();

  return name ? `Dr. ${name}` : "";
}

export function patientNameFromAppointment(item: any): string {
  const patient = item?.patientId ?? item?.bookPatientId;
  const title = String(patient?.title ?? "").trim();
  const fullName = String(patient?.fullName ?? "").trim();
  const name = [title, fullName].filter(Boolean).join(" ").trim();
  return name || "—";
}
